import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-remove-payment',
  templateUrl: './remove-payment.component.html',
  styleUrls: ['./remove-payment.component.scss']
})
export class RemovePaymentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/remove-payment/remove-payment.component.ts